import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { BrowserRouter } from "react-router-dom";
import "@fontsource/public-sans";
import AuthenticationProvider from "context/AuthenticationContext";
import AuthorizationProvider from "context/AuthorizationContext";
import DialogManagerProvider from "context/DialogManagerContext";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { it } from "date-fns/locale";
import { JoyToaster } from "components/styled_components";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "components/ErrorFallback";
import { QueryClient } from "@tanstack/react-query";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import localforage from "localforage";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: 1000 * 60 * 60 * 24, // 24 hours
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});

const persister = createAsyncStoragePersister({
  storage: localforage,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => window.location.reload()}
      >
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={it}>
          <PersistQueryClientProvider client={queryClient} persistOptions={{ persister }}>
            <BrowserRouter>
              <JoyToaster />
              <DialogManagerProvider>
                <AuthorizationProvider>
                  <AuthenticationProvider>
                    <App />
                  </AuthenticationProvider>
                </AuthorizationProvider>
              </DialogManagerProvider>
            </BrowserRouter>
          </PersistQueryClientProvider>
        </LocalizationProvider>
      </ErrorBoundary>
    </I18nextProvider>

  </React.StrictMode>
);

reportWebVitals();
